var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoutCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "42px",
    viewBox: "0 0 39 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FF07463F-866E-4ACD-B1BF-CB3952389674") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CMS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Other-pages---HOME-page",
    transform: "translate(-109.000000, -964.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(99.000000, 966.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    transform: "translate(11.750000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,14.8803387 L17.5,0 M10,5.01331125 C3.93861055,7.81016671 0.0348994975,13.9226164 0,20.6713593 C0.11119549,30.3526583 7.9457728,38.1099934 17.5,37.9988229 C27.0542283,38.1099934 34.888805,30.3526583 35,20.6713593 C34.9651015,13.9226164 31.0613905,7.81016671 25,5.01331125",
    id: "Vector-39"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutCopy);
export default __webpack_public_path__ + "static/media/Logout Copy.7378520ae500cb342fc453acbaa524ce.svg";
export { ForwardRef as ReactComponent };